import { useState } from "react"
import { Box, Popover, Stack, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { navigate } from "lib/routes/navigate"
import Iconify from "minimals-template/components/Iconify"
import { LinkedScenarioRow } from "./linked-scenario-row"

export function LinkedScenariosCell({ scenarios, count, align = "flex-end" }) {
    const [popoverAnchor, setPopoverAnchor] = useState(null)
    const list = scenarios || []
    const total = count ?? list.length

    if (!total) {
        return (
            <Typography variant="body2" color="text.secondary" sx={{ textAlign: "left" }}>
                {"\u2014"}
            </Typography>
        )
    }

    return (
        <>
            <Box
                data-cy="linked-scenarios-cell"
                sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: align,
                    gap: 1,
                    pl: 0.5,
                    py: 0.75,
                    borderRadius: 1,
                    cursor: "pointer",
                    "&:hover": { bgcolor: "action.hover" },
                }}
                onClick={openPopover}
            >
                <Iconify
                    icon="qlementine-icons:money-16"
                    width={20}
                    height={20}
                    sx={{ color: "common.black", flexShrink: 0 }}
                />
                <Typography variant="body2" sx={{ fontSize: 16, fontWeight: 500 }}>
                    {total}
                </Typography>
                <Iconify icon="ic:round-arrow-drop-down" width={24} sx={{ color: "text.primary" }} />
            </Box>
            <Popover
                open={Boolean(popoverAnchor)}
                anchorEl={popoverAnchor}
                onClose={closePopover}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                slotProps={{ paper: { sx: { p: 1, minWidth: 200 } } }}
            >
                <Stack spacing={0}>
                    <Repeat list={list} item={<LinkedScenarioRow onNavigate={handleNavigate} />} />
                </Stack>
            </Popover>
        </>
    )

    function openPopover(e) {
        e.stopPropagation()
        setPopoverAnchor(e.currentTarget)
    }

    function closePopover(e) {
        if (e?.stopPropagation) e.stopPropagation()
        setPopoverAnchor(null)
    }

    function handleNavigate(scenario) {
        closePopover()
        navigate(`/app/optimiser/scenarios/${scenario.id}`)
    }
}
